module.exports = __webpack_public_path__ + "img/step-1.f9b95f1b.png";